angular.module('dpw.components')

    .factory('redirectUriService', ['applicationService', 'organizationService', 'popupUtil', 'helpers', function (applicationService, organizationService, popupUtil, helpers) {
        return {
            siteType: {
                'Developer': 'developerSite',
                'Admin': 'adminSite'
            },

            hasRedirectUris: function (redirectUris) {
                var atLeastOneHasValue = _.some(redirectUris, function (redirectUri) {
                    return !_.isEmpty(redirectUri.uri);
                });

                return _.size(redirectUris) >= 1 && atLeastOneHasValue;
            },

            populateDefaultValue: function (data) {
                var defaultRedirectUri = _.get(RCDPW, 'defaultRedirectUri', 'https://www.ringcentral.com');
                this.normalizeRedirectUris(data);
                _.set(data, 'redirectUris[0].uri', defaultRedirectUri);
            },

            resolveMaxCount: function (application) {
                var defaultMaxCount = parseInt(_.get(RCDPW, 'maxRedirectURINumber', 20));
                var maxCountForBotAndMNA = 1;
                return applicationService.isBotApp(application) || applicationService.isNotificationApp(application) ?
                    maxCountForBotAndMNA : defaultMaxCount;
            },

            hasExceededMaxCount: function (application) {
                var maxCount = this.resolveMaxCount(application);
                if (_.size(application.redirectUris) > maxCount) {
                    this.showMaxCountExceededError(application);
                    return true;
                }
                return false;
            },

            showMaxCountExceededError: function (application) {
                popupUtil.ok({
                    content: prepareMessage.bind(this)()
                });

                function prepareMessage() {
                    var maxCount = this.resolveMaxCount(application);

                    var template = (
                        helpers.isSingularForm(maxCount) ?
                            RCDPW.Lang.MultipleRedirectUris.MAX_COUNT_EXCEEDED_SINGULAR :
                            RCDPW.Lang.MultipleRedirectUris.MAX_COUNT_EXCEEDED_PLURAL
                    );

                    var context = {
                        maxCount: maxCount,
                        appType: applicationService.getAppTypeById(application.type).text
                    };

                    return RCDPW.textInterpolate(template, context);
                }
            },

            containsWildcards: function (uri) {
                return _.includes(uri, '*');
            },

            isReadonly: function (obj) {
                return obj.isUnableToEdit;
            },

            isInvalid: function (obj) {
                var self = this;
                return !obj.isUnableToEdit && self.containsWildcards(obj.uri);
            },

            canUseLocalhostUris: function (application) {
                return !applicationService.isBotApp(application) && !applicationService.isNotificationApp(application);
            },

            hasUnusableLocalhostUri: function (application, obj) {
                if (this.canUseLocalhostUris(application)) {
                    return false;
                }

                var re = /^https?:\/\/(localhost|127.0.0.1)($|:|\?|#|\/)/i;
                return re.test(obj.uri);
            },

            /**
             * Judge whether the 'redirectUris' contains duplicated redirect URIs.
             *      if the specified URI is provided, the duplication situation of this URI will be returned.
             *
             * @param {Array} redirectUris - the collection of redirect URIs.
             * @param {Object} [item] - the specified URI item.
             * @returns {boolean} The duplication situation.
             */
            isDuplicated: function (redirectUris, item) {
                var isDuplicated = false;
                var uri = _.get(item, 'uri');
                var countInfo = _.countBy(redirectUris, function (obj) {
                    return obj.uri && obj.uri.toLowerCase();
                });

                if (_.isUndefined(item)) {
                    _.forEach(countInfo, function (count, uri) {
                        count >= 2 && uri !== '' && (isDuplicated = true);
                    });
                } else {
                    _.isString(uri) && uri !== '' && countInfo[uri.toLowerCase()] && countInfo[uri.toLowerCase()] >= 2 && (isDuplicated = true);
                }

                return isDuplicated;
            },

            isError: isError,

            isInsecure: function (errorRedirectUris, obj) {
                return _.get(_.find(errorRedirectUris, 'uri', obj.uri), 'isInsecure');
            },

            isRestApiAppRedirectUrisValid: function(redirectUris, application) {
                if (RCDPW.isAdminSite) {
                    return true;
                }
                var isRestApiAppGrantTypeCode = applicationService.isRestApiAppGrantTypeCode(application);
                if (!isRestApiAppGrantTypeCode) {
                    return true;
                }
                if (redirectUris.length === 0) {
                    return false;
                }
                return _.some(redirectUris, this.isRestApiAppRedirectUriValid);
            },

            isRestApiAppRedirectUriValid: function(redirectUri) {
                if ( typeof redirectUri.uri === 'string' && redirectUri.uri.trim() === '') {
                    return false;
                }
                return Boolean(redirectUri.uri);
            },

            isOrgAllowUrl: function (item, application) {
                var redirectUri = item.uri;
                if (!redirectUri) {
                    return true;
                }
                if (/^https?:\/\/.+$/.test(redirectUri)) {
                    return true;
                }
                var isUserNativeOrg = this.isUserNativeOrg(application);
                if (isUserNativeOrg) {
                    return /^[a-z0-9-]*:\/\/.+/i.test(redirectUri);
                } else {
                    return /^chrome-extension:\/\/.+/.test(redirectUri);
                }
            },

            isUserNativeOrg: function (application) {
                if (RCDPW.isAdminSite) {
                    return true;
                }
                if (!application.organization) {
                    return false;
                }

                return organizationService.isNative(application.organization);
            },

            redirectUriHandler: function (scope, redirectUris, data, defaultErrorHandler) {
                var ctrl = this;
                var errors = _.get(data, 'errors');
                var errorRedirectUris = _.filter(errors, function (err) {
                    return err.parameter === 'redirectUris' || err.parameterName === 'redirectUris';
                });

                if (_.size(errorRedirectUris) === 0) {
                    defaultErrorHandler();
                    return;
                }

                _.isFunction(ctrl.oldHttpRedirectUriHandler) && ctrl.oldHttpRedirectUriHandler();

                ctrl.errorRedirectUris = _.map(errorRedirectUris, function (item) {
                    return {
                        uri: item.badValue || item.parameterValue,
                        isInsecure: (item.error || item.message).indexOf('security') > 0
                    };
                });

                var unwatchFnList = ctrl.errorRedirectUriUnwatchFnList;
                _.forEach(unwatchFnList, function (unwatchFn) {
                    unwatchFn();
                });

                ctrl.errorRedirectUriUnwatchFnList = [];
                _.forEach(redirectUris, function (item) {
                    if (isError(ctrl.errorRedirectUris, item)) {
                        var unwatchFn = scope.$watch(function () {
                            return item.uri;
                        }, function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                _.remove(ctrl.errorRedirectUris, function (item) {
                                    return item.uri === oldVal;
                                });
                                unwatchFn();
                            }
                        });
                        ctrl.errorRedirectUriUnwatchFnList.push(unwatchFn);
                    }
                });
            },

            isRedirectUrisValid: function (redirectUris, application) {
                var self = this;
                var redirectUriValid = _.every(redirectUris, function (item) {
                    return !self.isInvalid(item) && !self.hasUnusableLocalhostUri(application, item) && self.isOrgAllowUrl(item, application);
                });
                return redirectUriValid && !self.isDuplicated(redirectUris) && self.isRestApiAppRedirectUrisValid(redirectUris, application);
            },

            normalizeRedirectUris: function (data) {
                if (_.size(data.redirectUris) === 0) {
                    data.redirectUris = [{
                        uri: '',
                        isUnableToEdit: false
                    }];
                }
            },

            arrayToCollection: function (redirectUris, siteType) {
                var self = this;
                var isDeveloperSite = siteType === self.siteType.Developer;

                return _.map(redirectUris, function (uri) {
                    return {
                        uri: uri,
                        isUnableToEdit: isDeveloperSite ? self.containsWildcards(uri) : false
                    };
                });
            },

            collectionToArray: function (redirectUris) {
                return _.map(redirectUris, function (obj) {
                    return obj.uri;
                });
            }
        };

        function isError(errorRedirectUris, obj) {
            return !!_.find(errorRedirectUris, 'uri', obj.uri);
        }
    }])

    .directive('dpwMultipleRedirectUris', ['redirectUriService', function (redirectUriService) {
        return {
            restrict: 'A',
            scope: {
                siteType: '@',
                isDisabled: '@',
                redirectUris: '=',
                errorRedirectUris: '=',
                application: '<',
                onMaxCountChange: '&'
            },
            bindToController: true,
            controller: ['$scope', 'applicationService', function ($scope, applicationService) {
                var self = this;
                var maxCount;

                $scope.$watch('ctrl.application.type', function () {
                    maxCount = redirectUriService.resolveMaxCount(self.application);
                    _.isFunction(self.onMaxCountChange) && self.onMaxCountChange({maxCount: maxCount});
                });

                if (!_.isArray(self.redirectUris)) {
                    throw Error('\'redirectUris\' is not an array.');
                }

                self.isReadonly = function () {
                };
                self.isInvalid = function () {
                };
                self.isDuplicated = function (obj) {
                    return redirectUriService.isDuplicated(self.redirectUris, obj);
                };
                self.isRestApiAppRedirectUrisValid = function (redirectUris, application) {
                    return redirectUriService.isRestApiAppRedirectUrisValid(redirectUris, application);
                };
                self.isOrgAllowUrl = function (uri, application) {
                    return redirectUriService.isOrgAllowUrl(uri, application);
                };
                self.isError = function (obj) {
                    return redirectUriService.isError(self.errorRedirectUris, obj);
                };
                self.isInsecure = function (obj) {
                    return redirectUriService.isInsecure(self.errorRedirectUris, obj);
                };
                self.hasUnusableLocalhostUri = function (obj) {
                    return redirectUriService.hasUnusableLocalhostUri(self.application, obj);
                };
                self.canUseLocalhostUris = function () {
                    return redirectUriService.canUseLocalhostUris(self.application);
                };
                self.showWarning = function (obj) {
                    return self.isInvalid(obj) || self.isDuplicated(obj) || self.isError(obj) || self.hasUnusableLocalhostUri(obj);
                };
                self.shouldHideAddMore = function () {
                    return applicationService.isBotApp(self.application) ||
                        applicationService.isNotificationApp(self.application);
                };

                self.siteType === redirectUriService.siteType.Developer && initWildcardsRestriction();

                self.addRedirectUri = function () {
                    if (self.isUnavailableToAdd()) {
                        return;
                    }

                    self.redirectUris.push({
                        uri: '',
                        isUnableToEdit: false
                    });
                };
                self.removeRedirectUri = function (idx) {
                    self.redirectUris.splice(idx, 1);
                };
                self.isUnavailableToAdd = function () {
                    return self.redirectUris.length >= maxCount || _.some(self.redirectUris, function (item) {
                        return item.uri === '';
                    }) || self.isDisabled === 'true';
                };
                self.errorMessageConfig = {
                    SHOULD_NOT_CONTAIN_WILDCARD: RCDPW.Lang.MultipleRedirectUris.SHOULD_NOT_CONTAIN_WILDCARD,
                    SHOULD_NOT_BE_DUPLICATED: RCDPW.Lang.MultipleRedirectUris.SHOULD_NOT_BE_DUPLICATED,
                    HTTP_PROTOCOL_NOT_ALLOWED: RCDPW.Lang.MultipleRedirectUris.HTTP_PROTOCOL_NOT_ALLOWED,
                    LOCALHOST_NOT_ALLOWED_FOR_BOT_APP_AND_MNA: RCDPW.Lang.MultipleRedirectUris.LOCALHOST_NOT_ALLOWED_FOR_BOT_APP_AND_MNA,
                    HTTP_PROTOCOL_ALLOWED_EXCEPTION: RCDPW.Lang.MultipleRedirectUris.HTTP_PROTOCOL_ALLOWED_EXCEPTION,
                    REQUIRED: 'This field is required.'
                };

                function initWildcardsRestriction() {
                    self.isReadonly = function (obj) {
                        return redirectUriService.isReadonly(obj);
                    };
                    self.isInvalid = function (obj) {
                        return redirectUriService.isInvalid(obj);
                    };
                }
            }],
            controllerAs: 'ctrl',
            templateUrl: 'dpw-multiple-redirect-uris.html'
        };
    }]);
